import { IssuesCloseOutlined } from "@ant-design/icons";
import { DOCS_URLS } from "@p0security/frontend-core";
import { ZeroStatePage } from "components/Dashboard/components/common/ZeroStatePage";
import { EnvironmentDocsContext } from "components/Environment/contexts/EnvironmentDocsContext";
import { useContext } from "react";

import { FindingsFilterBar } from "../components/FindingsFilterBar";
import { MonitorList } from "../components/MonitorList";

export const Findings: React.FC = () => {
  const { hasEnvironments } = useContext(EnvironmentDocsContext);

  return hasEnvironments ? (
    <div>
      <FindingsFilterBar />
      <MonitorList actionTypes={[]} variant="findingsTable" />
    </div>
  ) : (
    <ZeroStatePage
      title="Manage the posture of your cloud identities"
      description="Posture helps you identify and remediate risks in your cloud environments."
      icon={<IssuesCloseOutlined />}
      docLink={DOCS_URLS.IAM_ASSESSMENT}
    />
  );
};
